import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface IInfluencerAcceptAnnexModalProps {
    show: boolean;
    closeModal: () => void;
    date: string;
    disableButton?: boolean;
    action: () => void;
}

export function InfluencerAcceptAnnexModal({
    show,
    closeModal,
    date,
    disableButton,
    action,
}: IInfluencerAcceptAnnexModalProps) {
    const { t } = useTranslation();
    const prefix = 'influencer.offer_management.modal';

    return (
        <Modal show={show} onHide={closeModal} className="modal-dark" centered={true}>
            <Modal.Body>
                <div className="mt-4 d-flex align-items-center justify-content-center flex-column">
                    <h4 className="text-primary text-center">{t(`${prefix}.accept_annex_title`)}</h4>
                </div>
                <div className="text-center">
                    <p>{t(`${prefix}.accept_annex_desc`, { date })}</p>
                    <div className="bg-light default-radius p-3 text-muted font-12">
                        {t(`${prefix}.accept_annex_hint`)}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button onClick={closeModal} variant="outline-primary" className="btn-sm mx-2">
                    {t('general.button.cancel')}
                </Button>
                <Button disabled={disableButton} variant="primary" className="btn-sm mx-2" onClick={action}>
                    {t(`${prefix}.sign`)}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
